import { render, staticRenderFns } from "./pdf_preview.vue?vue&type=template&id=383a205c&scoped=true"
import script from "./pdf_preview.vue?vue&type=script&lang=js"
export * from "./pdf_preview.vue?vue&type=script&lang=js"
import style0 from "./pdf_preview.vue?vue&type=style&index=0&id=383a205c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a205c",
  null
  
)

export default component.exports